import PropTypes from 'prop-types';
import React from 'react';
import InstructionsView from 'components/tools/InstructionsView';
import {FormattedMessage} from 'react-intl';

const Instructions = ({nextView}) => <InstructionsView
  onSubmit={nextView}
  title='tools.replace.tool.description'
  remember={[
    'tools.replace.physical.address',
    'tools.replace.allow.find',
    'tools.replace.eight.fields',
  ]}
  instructions={[
    {
      title: 'tools.instructions.run.report',
      body: 'tools.replace.click.start',
    },
    {
      title: 'tools.replace.find.keyboard',
      body: <div>
        <p><FormattedMessage id="tools.replace.find.replace" /></p>
        <p><small>(<FormattedMessage id="tools.replace.report.printed" />).</small></p>
      </div>,
    },
    {
      title: 'tools.replace.replace.word',
      body: 'tools.replace.replace.field',
    },
  ]}
  confirmTwice={false}
/>;

Instructions.propTypes = {
  nextView: PropTypes.func.isRequired,
};


export default Instructions;
